import { createSelector } from 'reselect';
import * as addresses from '../../api/countryApi';

const addressComparator = (a, b, lng) => {
  if (a[`name${lng.toUpperCase()}`] > b[`name${lng.toUpperCase()}`]) {
    return 1;
  }
  if (a[`name${lng.toUpperCase()}`] < b[`name${lng.toUpperCase()}`]) {
    return -1;
  }
  return 0;
};

const GET_ACCIDENT_CITY_VILLAGES = 'efes/CMTPLForm/AccidentInfo/GET_ACCIDENT_CITY_VILLAGES';
const GET_ACCIDENT_CITY_VILLAGES_SUCCESS = 'efes/CMTPLForm/AccidentInfo/GET_ACCIDENT_CITY_VILLAGES_SUCCESS';
const GET_ACCIDENT_CITY_VILLAGES_FAIL = 'efes/CMTPLForm/AccidentInfo/GET_ACCIDENT_CITY_VILLAGES_FAIL';

const GET_CAR_CITY_VILLAGES = 'efes/CMTPLForm/AccidentInfo/GET_CAR_CITY_VILLAGES';
const GET_CAR_CITY_VILLAGES_SUCCESS = 'efes/CMTPLForm/AccidentInfo/GET_CAR_CITY_VILLAGES_SUCCESS';
const GET_CAR_CITY_VILLAGES_FAIL = 'efes/CMTPLForm/AccidentInfo/GET_CAR_CITY_VILLAGES_FAIL';

const initialState = {
  accCityVillages: [],
  accCityVillagesLoading: false,
  accCityVillagesError: null,

  carCityVillages: [],
  carCityVillagesLoading: false,
  carCityVillagesError: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ACCIDENT_CITY_VILLAGES:
      return {
        ...state,
        accCityVillagesLoading: true,
        accCityVillages: [],
        accCityVillagesError: null,
      };
    case GET_ACCIDENT_CITY_VILLAGES_SUCCESS:
      return {
        ...state,
        accCityVillagesLoading: false,
        accCityVillages: action.result,
      };
    case GET_ACCIDENT_CITY_VILLAGES_FAIL:
      return {
        ...state,
        accCityVillagesLoading: false,
        accCityVillagesError: action.error,
      };

    case GET_CAR_CITY_VILLAGES:
      return {
        ...state,
        carCityVillagesLoading: true,
        carCityVillages: [],
        carCityVillagesError: null,
      };
    case GET_CAR_CITY_VILLAGES_SUCCESS:
      return {
        ...state,
        carCityVillagesLoading: false,
        carCityVillages: action.result,
      };
    case GET_CAR_CITY_VILLAGES_FAIL:
      return {
        ...state,
        carCityVillagesLoading: false,
        carCityVillagesError: action.error,
      };
    default:
      return state;
  }
}

export function getAccCityVillages(regionId) {
  return {
    actions: [
      { type: GET_ACCIDENT_CITY_VILLAGES },
      { type: GET_ACCIDENT_CITY_VILLAGES_SUCCESS },
      { type: GET_ACCIDENT_CITY_VILLAGES_FAIL, showError: true },
    ],
    promise: addresses
      .fetchCityVillages(regionId)
      .then((resp) => resp.citiesVillages || []),
  };
}

export const sortedAccCityVillages = createSelector(
  (state) => state.cmtplAdresses.accCityVillages,
  (_, language) => language,
  (cityVillages, language) => cityVillages.sort((a, b) => addressComparator(a, b, language)),
);

export function getCarCityVillages(regionId) {
  return {
    actions: [
      { type: GET_CAR_CITY_VILLAGES },
      { type: GET_CAR_CITY_VILLAGES_SUCCESS },
      { type: GET_CAR_CITY_VILLAGES_FAIL, showError: true },
    ],
    promise: addresses
      .fetchCityVillages(regionId)
      .then((resp) => resp.citiesVillages || []),
  };
}

export const sortedCarCityVillages = createSelector(
  (state) => state.cmtplAdresses.carCityVillages,
  (_, language) => language,
  (cityVillages, language) => cityVillages.sort((a, b) => addressComparator(a, b, language)),
);
